import { PaginationProps } from "react-bootstrap";
import { OutageViewModelWithContacts } from "../../api/generated/models";
import { IAdminOutages } from "../../state-management/slices/outages/outages.slice";

export interface IPaginationProps extends PaginationProps {
  data: OutageViewModelWithContacts[] | null;
  currentPage: number;
  totalCount: number | null;
  pageSize?: number;
}

export const DefaultPaginationProps = {
  data: null,
  pageSize: 50,
};
